export function getFirstLetters(char: string) {
  if (!char) {return '';}
  return char.split(' ').map(w => w[0].toUpperCase()).join('');
}
